import {connect} from 'react-redux';
import ComparableColumnsHeader from '../components/ComparableColumnsHeader';
import * as comparableListingsActions from '../actionCreators/comparableListings';
import * as comparableSalesActions from '../actionCreators/comparableSales';
import * as comparableRentalsActions from '../actionCreators/comparableRentals';

const getComparableType = (type) => {
  if(type === 'Rental'){
    return 'comparableRentals';
  }
  return type === 'Sale' ? 'comparableSales' : 'comparableListings';
};

const mapStateToProps = (state, ownProps) => {
  const comparableType = getComparableType(ownProps.comparablesType);

  return {
    records: state[comparableType].suggested.length,
    selectAll: state[comparableType].selectAll,
    pagination: state[comparableType].pagination,
    fetching: state[comparableType].fetching,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onUpdateSelectAll: (event, {checked}) => {
      const comparableType = getComparableType(ownProps.comparablesType);
      switch (comparableType) {
        case 'comparableSales':
          dispatch(comparableSalesActions.updateSelectAll(checked));
          break;
        case 'comparableListings':
          dispatch(comparableListingsActions.updateSelectAll(checked));
          break;
        case 'comparableRentals':
          dispatch(comparableRentalsActions.updateSelectAll(checked));
          break;
        default:
          throw new Error(`Failed to find comparableType '${comparableType}'`);
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComparableColumnsHeader);